var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import Signal0 from '../../icons/Signal0';
import Signal1 from '../../icons/Signal1';
import Signal2 from '../../icons/Signal2';
import Signal3 from '../../icons/Signal3';
import Signal4 from '../../icons/Signal4';
import Signal5 from '../../icons/Signal5';
function rangeBetween(value, min, max) {
    return value >= min && value < max;
}
const DeviceSignalState = (_a) => {
    var { signalQuality, vendor } = _a, props = __rest(_a, ["signalQuality", "vendor"]);
    if (typeof signalQuality !== 'number') {
        return _jsx(Signal0, Object.assign({}, props), void 0);
    }
    if (vendor === 'monnit') {
        if (signalQuality >= 0.8) {
            return _jsx(Signal5, Object.assign({}, props), void 0);
        }
        else if (rangeBetween(signalQuality, 0.6, 8)) {
            return _jsx(Signal4, Object.assign({}, props), void 0);
        }
        else if (rangeBetween(signalQuality, 0.4, 0.6)) {
            return _jsx(Signal3, Object.assign({}, props), void 0);
        }
        else if (rangeBetween(signalQuality, 0.2, 0.4)) {
            return _jsx(Signal2, Object.assign({}, props), void 0);
        }
        else if (rangeBetween(signalQuality, 0.01, 0.2)) {
            return _jsx(Signal1, Object.assign({}, props), void 0);
        }
        return _jsx(Signal0, Object.assign({}, props), void 0);
    }
    else {
        if (signalQuality >= -34) {
            return _jsx(Signal5, Object.assign({}, props), void 0);
        }
        else if (rangeBetween(signalQuality, -49, -34)) {
            return _jsx(Signal4, Object.assign({}, props), void 0);
        }
        else if (rangeBetween(signalQuality, -64, -49)) {
            return _jsx(Signal3, Object.assign({}, props), void 0);
        }
        else if (rangeBetween(signalQuality, -79, -64)) {
            return _jsx(Signal2, Object.assign({}, props), void 0);
        }
        else if (rangeBetween(signalQuality, -87, -79)) {
            return _jsx(Signal1, Object.assign({}, props), void 0);
        }
        return _jsx(Signal0, Object.assign({}, props), void 0);
    }
};
export default DeviceSignalState;
